export * from './confirmation/confirmation.component';
export * from './form-layout/form-layout.component';

export type FormWizardStep = 'form-layout' | 'confirmation';
